export const salesReportSubMenu = [{
  path: '/report/salesReport/list',
  component: () => import('@/views/report/sales-report/list.vue'),
  name: 'report.title',
  meta: {
    title: 'report.salesReport.title',
    roles: ['Super Admin', 'Admin', 'Invoice Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager', 'Agent', 'Branch Manager', 'Payment Manager'],
    noCache: true,
    hidden: false,
    icon: 'tree-table'
  }
}];